import serverVars from 'server-vars';
import thunk from 'redux-thunk';

/* Queries */
import pdpRespRoot from '../../queries/pdpRespRoot';

/* Reducers */
import { defaultReducers } from '../../reducers/reducerUtils';
import pdpPreviewPage from '../../reducers/pdpRespPreviewPageReducer';
import pdpPrint from '../../reducers/pdpRespPrintReducer';
import pdpRespNotificationsReducer from '../../reducers/pdpRespNotificationsReducer';
import similarItems from '../../reducers/pdpRespSimilarItemsReducer';
import trackingReducer from '../../reducers/trackingRespReducer';

/* Components */
import PdpRespLayout from '../../pdp/PdpRespLayout';

/* Helpers */
import { createEntry } from '../createEntry';
import { initializeDBL } from 'dibs-buyer-layout/src/entries';

/* Actions */
import { setIsPdpRespPreviewPage } from '../../actions/pdpRespPreviewPageActions';
import { waitToFireInitialTracking } from '../../actions/trackingRespActions';

/* Notifications */
import pdpRespNotifications from '../../pdp/PdpRespNotifications/pdpRespNotifications';

const isPdpRespPreviewPage = serverVars.get('isPdpRespPreviewPage');

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    autoRunNotificationQueue: !isPdpRespPreviewPage,
    middleware: [thunk],
    notifications: pdpRespNotifications,
    reducers: {
        pdpPrint,
        pdpPreviewPage,
        pdpRespNotificationsReducer,
        similarItems,
        trackingReducer,
        ...defaultReducers,
    },
};

initializeDBL(options).then(({ store }) => {
    store.dispatch(setIsPdpRespPreviewPage({ isPdpRespPreviewPage }));
    // need to wait to fire page view on pdp
    store.dispatch(waitToFireInitialTracking());
    createEntry({
        Container: PdpRespLayout,
        store,
        query: pdpRespRoot,
    });
});
